import React, { useState, useEffect } from "react";
import "../Components Styles/DesktopNavbar.css";
import { GoSearch } from "react-icons/go";
import img1 from "../Images/Caraousal_Images/Trending1.jpg";
import { IoCloseSharp, IoHeartOutline } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GrLocation } from "react-icons/gr";
import { CiUser, CiLocationOn } from "react-icons/ci";
import { BsHandbag } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { a17, a3, s1, s3 } from "../Api/RootApiPath";
import { removeFromCart, userLoggedIn } from "../../redux/action/Actions";

export default function DesktopNavbar({ goldList, silverList }) {
  const dispatch = useDispatch();
  const handleRemoveFromBag = (index) => {
    dispatch(removeFromCart(index));
  };

  const [loading, setLoading] = useState(true);
  const bagItems = useSelector((state) => state);

  const uniqueItem = bagItems.reducer2;
  const userDetails = bagItems.reducer4;
  const totalItems = bagItems.reducer2.length;

  let totalPrice = 0;
  const navigate = useNavigate();
  const loggedIn = (user) => {
    dispatch(userLoggedIn(user));
  };
  let orderId = "";
  const location = useLocation();
  let params = "";
  params = new URLSearchParams(location.search);
  let Customer_id = "";
  Customer_id = params.get("customerId");
  console.log(Customer_id);
  const accountDetails = async () => {
    const formData = {
      Id: Customer_id,
    };

    try {
      const response = await fetch(a3, {
        method: "POST",
        // body: formData,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      console.log("Data:", data);
      loggedIn([data.data]);
      // loggedOut(userDetails);
      setLoading(false);
      // userDetails = data.data[0];
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
      navigate("/customerloginpage");
      alert(error);
    }
  };
  useEffect(() => {
    if (Customer_id !== null) {
      accountDetails();
    }
  }, [Customer_id]);

  const [popUp, setPopup] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleMouseEnter = () => {
    setPopup(true);
  };
  const handleMouseLeave = () => {
    setPopup(false);
  };
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  const [cartItems, setCartItems] = useState([]);

  return (
    <div className="navbarMain">
      <div className="navbar">
        <div className="searchAndStoreBox">
          <div className="searchAndStoreItem" style={{ marginLeft: "2rem" }}>
            <GoSearch style={{ marginInline: "0.5rem" }} spacing="2rem" />
            <div
              className="searchBtn"
              onClick={() => handleMouseEnter()}
              style={{ cursor: "pointer" }}
            >
              SEARCH
            </div>
          </div>
          {popUp === true ? (
            <div className="searchBarBoxMain" data-aos="fade-up">
              <AiOutlineClose
                className="searchBarBoxCloseBtn"
                size={"4rem"}
                onClick={() => setPopup(false)}
              />

              <h1 style={{ color: "white", margin: "2rem" }}>
                Search Any Product Here...
              </h1>
              <input type="text" />

              <button>Search</button>
            </div>
          ) : null}
          <div className="searchAndStoreItem">
            <CiLocationOn size={"1.2rem"} />
            <Link to="/stores">
              <div style={{ marginLeft: "0.5rem" }}>STORES</div>
            </Link>
          </div>
        </div>
        <div className="links">
          <li className="dropdown">
            <div className="link">GOLD</div>
            <div className="dropdown-content">
              <div className="dropdown-box">
                <div className="firstBox">
                  <div
                    style={{ marginLeft: "0rem", padding: "0rem" }}
                    className="allCategoryHead"
                  >
                    <h3>Shop By category</h3>
                  </div>
                  <div className="allCategoryItems">
                    <ul>
                      <Link to="/category/coin">
                        <li>GOLD COINS</li>
                      </Link>
                      <Link to="/category/coin">
                        <li>GOLD MANGALSUTRA</li>
                      </Link>
                      <Link to="/category/coin">
                        <li>GOLD KADAS</li>
                      </Link>
                      <li>GOLD MANGALSUTRA</li>
                      <li>GOLD KADAS</li>
                    </ul>
                  </div>
                </div>
                <div className="featured">
                  <h2>Featured</h2>
                  <div className="featuredProductImage">
                    <div className="featuredProductOffer">
                      <Link to="/category/coin">
                        <button className="shopNowBtn">SHOP NOW</button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li className="dropdown">
            <div className="link">SILVER</div>
            <div className="dropdown-content">
              <div className="dropdown-box">
                <div className="firstBox">
                  <div
                    style={{ marginLeft: "0rem", padding: "0rem" }}
                    className="allCategoryHead"
                  >
                    <h3>Shop By category</h3>
                  </div>
                  <div className="allCategoryItems otherBullet">
                    <ul>
                      {silverList.map((x, y) => (
                        <Link to={`/category/${x.name}`} key={y}>
                          <li>{x.name}</li>
                        </Link>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="featured">
                  <h2>Featured</h2>
                  <div className="featuredProductImage">
                    <div className="featuredProductOffer">
                      <Link to="/category/coin">
                        <button className="shopNowBtn">SHOP NOW</button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li className="link">
            <Link to="/shoppage">WORLD OF GHARE'S</Link>
          </li>

          <li className="link">
            <Link to="/category/gift">GIFTS</Link>
          </li>
        </div>
        <div className="favAndBag">
          {userDetails.length === 0 ? (
            <div className="signIn">
              <CiUser size={"1rem"} />
              <span className="link" style={{ paddingLeft: "0.5rem" }}>
                <Link to="/customerloginpage">SIGN IN</Link>
              </span>
            </div>
          ) : (
            <div className="signIn">
              <CiUser size={"1rem"} />
              <span className="link" style={{ paddingLeft: "0.5rem" }}>
                {/* {Customer_id === null || loading ? ( */}
                <Link to={`/customerprofile?customerId=${userDetails[0].id}`}>
                  {`${userDetails[0].firstName} ${userDetails[0].lastName}`}
                </Link>
                {/* ) : (
                  // <Link to={`/customerprofile?customerId=${Customer_id}`}>
                  //   {`${userDetails[0].firstName} ${userDetails[0].lastName}`}
                  // </Link>
                  <div className="signIn">
                    <CiUser size={"1rem"} />
                    <span className="link" style={{ paddingLeft: "0.5rem" }}>
                      <Link to="/customerloginpage">SIGN IN</Link>
                    </span>
                  </div>
                )} */}
              </span>
            </div>
          )}
          <div className="bag">
            <div className="dropdown2">
              <div className="dropbtn">
                <BsHandbag className="bagIcon" />

                {totalItems != 0 ? (
                  <div className="bagTotalCount">{totalItems}</div>
                ) : null}
                <span className="link" style={{ paddingLeft: "0.5rem" }}>
                  MY BAG
                </span>
              </div>
              <div className="dropdown-content2">
                <div className="dropdown-box">
                  <div className="myBagMainBox">
                    {uniqueItem == "" ? (
                      <h2>Empty</h2>
                    ) : (
                      uniqueItem.map((x, y) => {
                        const productPrice = x.count * x.finalPrice; // calculate price for this product
                        totalPrice += productPrice; // add price to total
                        return (
                          <div>
                            <div className="myBagProducts">
                              <img
                                className="myBagProductImage"
                                src={`${s3}/${x.image}`}
                                alt={"ProductImage"}
                                key={y}
                              />
                              <div className="myBagProductDetails">
                                <p>{x.title}</p>
                                <p>
                                  {x.count} x ₹{x.price * x.count}
                                </p>
                              </div>
                              <div className="closeMyBagBtn">
                                <IoCloseSharp
                                  style={{ cursor: "pointer" }}
                                  size={"1.5rem"}
                                  onClick={() => handleRemoveFromBag(x)}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                    {uniqueItem.length != [] ? (
                      <div className="myBagTotalBox">
                        <span>Subtotal :</span>
                        <span>₹{totalPrice.toFixed(2)}</span>
                      </div>
                    ) : null}
                    {uniqueItem.length != [] ? (
                      <div className="myBagBtns">
                        <Link to="/checkoutmain">
                          <button id="viewCartBtn">View Cart</button>
                        </Link>
                        <Link to="/checkoutmain">
                          <button id="checkoutBtn">Checkout</button>
                        </Link>
                      </div>
                    ) : (
                      <div style={{ margin: "1rem" }}>
                        Add Something to cart
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
